'use client'
import {Box} from "@mui/material"
import {alpha, styled} from "@mui/material/styles"


export const GlassBox = styled(Box)(({ theme }) => [
  {
    padding: theme.spacing(4),
    borderRadius: theme.spacing(3),
    // background: theme.palette.background.paper,
    border: "1px solid rgba(133, 119, 126, 0.05)",
    backdropFilter: "blur(10px) saturate(181%)",
    background: alpha(theme.palette.background.default, .075)
  },
  theme.applyStyles('dark', {
    background: alpha(theme.palette.background.paper, .85),
    border: "1px solid rgba(133, 119, 126, 0.05)",
    backdropFilter: "blur(10px) saturate(181%)",
  }),
])

export const ToolPadGlassBox = styled(Box)(({ theme }) => [
  {
    padding: theme.spacing(4),
    borderRadius: theme.spacing(3),
    // background: theme.palette.background.paper,
    border: "1px solid rgba(133, 119, 126, 0.05)",
    backdropFilter: "blur(10px) saturate(181%)",
    background: alpha(theme.palette.common.white, .55)
  },
  theme.applyStyles('dark', {
    background: alpha(theme.palette.background.paper, .85),
    // background: alpha(theme.palette.background.paper, .35),
    border: "1px solid rgba(133, 119, 126, 0.15)",
    backdropFilter: "blur(10px) saturate(181%)",
  }),
])

export const ToolPadBlackGlassBox = styled(Box)(({ theme }) => [
  {
    color: theme.palette.common.white,
    padding: theme.spacing(4),
    borderRadius: theme.spacing(3),
    border: "1px solid rgba(133, 119, 126, 0.05)",
    backdropFilter: "blur(10px) saturate(181%)",
    background: alpha(theme.palette.common.black, .9)
  },
  theme.applyStyles('dark', {
    background: alpha(theme.palette.background.paper, .85),
    // background: alpha(theme.palette.background.paper, .35),
    border: "1px solid rgba(133, 119, 126, 0.05)",
    backdropFilter: "blur(10px) saturate(181%)",
  }),
])